import { render, staticRenderFns } from "./SectionTile.vue?vue&type=template&id=ff6ac7ce"
import script from "./SectionTile.vue?vue&type=script&lang=js"
export * from "./SectionTile.vue?vue&type=script&lang=js"
import style0 from "./SectionTile.vue?vue&type=style&index=0&id=ff6ac7ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports